import type { AccountConstraintRow } from './types';

export const ACCOUNT_GROUPS = [
  { label: '1. Tài sản ngắn hạn', value: 'Tài sản ngắn hạn', shortCode: '1' },
  { label: '2. Tài sản dài hạn', value: 'Tài sản dài hạn', shortCode: '2' },
  { label: '3. Nợ phải trả', value: 'Nợ phải trả', shortCode: '3' },
  { label: '4. Vốn chủ sở hữu', value: 'Vốn chủ sở hữu', shortCode: '4' },
  { label: '5. Doanh thu', value: 'Doanh thu', shortCode: '5' },
  { label: '6. Chi phí sản xuất, kinh doanh', value: 'Chi phí sản xuất, kinh doanh', shortCode: '6' },
  { label: '7. Thu nhập khác', value: 'Thu nhập khác', shortCode: '7' },
  { label: '8. Chi phí khác', value: 'Chi phí khác', shortCode: '8' },
  { label: '9. Xác định kết quả kinh doanh', value: 'Xác định kết quả kinh doanh', shortCode: '9' },
  { label: 'N. Tài khoản ngoài bảng', value: 'Tài khoản ngoài bảng', shortCode: 'N' }
] as const;

export type AccountGroupValue = (typeof ACCOUNT_GROUPS)[number]['value'];

export const DEFAULT_ACCOUNT_GROUP: AccountGroupValue = ACCOUNT_GROUPS[0].value;
export const ACCOUNT_PAGE_SIZE = 500;
export const ACCOUNT_FETCH_PAGE_SIZE = 5000;

export const DEFAULT_CONSTRAINT_NAMES = [
  'Bộ phận',
  'Vụ việc',
  'Hợp đồng',
  'Đợt thanh toán',
  'Khế ước',
  'Phí',
  'Sản phẩm',
  'Lệnh sản xuất',
  'C/p không h/lệ'
] as const;

export const DEFAULT_CONSTRAINT_ROWS: Omit<AccountConstraintRow, 'id'>[] = DEFAULT_CONSTRAINT_NAMES.map(name => ({
  objectName: name,
  requireInput: false
}));
